import TextCreate from 'core/display/simple/Text'
import { Sprite } from 'pixi.js'
import { LocalizationService } from 'services/LocalizationService'
import { signal } from 'services/SignalsService'
import { popups } from 'settings/popups'
// import {StoreageService} from "../../../../services/StoreageService";
// import {FormatService} from "../../../../services/FormatService";

export default class PopupText extends TextCreate {
  constructor(data) {
    super(data)

    signal.on('POPUP:show', (value) => {
      const popupKey = value || 'error.code'
      if (LocalizationService.get(popups[popupKey]) && LocalizationService.get(popups[popupKey].text)) {
        this.update(LocalizationService.get(popups[popupKey].text))
      }

      if(popups[popupKey] && popups[popupKey].img){
        popups[popupKey].text ? this.text.visible = true : this.text.visible = false
        const sprite = Sprite.from(popups[popupKey].img)
        sprite.x = 230
        sprite.y = 45
        sprite.anchor.set(0.5)
        sprite.scale.set(0.4)
        this.addChild(sprite)
      }
    })

    signal.on('FREEBET:END', () => {
      this.update(LocalizationService.get('freeBetEnd'))
    })
  }

  update(value, resize = true) {
    super.update(value, resize)
  }
}
